<template lang="html">
  <div id="validator-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <!-- Paso 1 -->
        <div class="col-lg-11 box-validation-form" v-if="step == 1">
          <div class="row">
            <div class="col-lg-6 col-text">
              <h5 class="title">Validador de autenticidad</h5>

              <p>
                Ingresa el número de documento localizado en la parte superior derecha.
              </p>
            </div>

            <div class="col-lg-6 col-xl-5 offset-xl-1 col-form">
              <b-form inline @submit="onSubmit">
                <b-form-group class="form-group-s1">
                  <b-form-input
                    v-model="form.number"
                    type="text"
                    placeholder=""

                  ></b-form-input>
                </b-form-group>

                <b-button type="submit" id="miBoton" class="btn btn-s1 bg-cprimary">Buscar</b-button>
              </b-form>
            </div>
          </div>
        </div>
        <!--  -->

        <!-- Paso 2 -->
        <div class="col-lg-11 box-validation-info" v-if="step == 2">
          <div class="row" v-if="typesearch == 1">
            <div class="col-12 col-title">
              <h5 class="title-1">Resultados para el ID {{form.number}}</h5>
            </div>

            <div class="col-12 col-table">
              <div class="table-responsive-lg">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="cell-company" scope="col">Empresa</th>
                      <th class="cell-company" scope="col">Cliente</th>
                      <th class="cell-company" scope="col">Fecha</th>
                      <th scope="col">ID</th>
                      <th class="cell-buttons" scope="col"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(r, rInx) in results" :key="'rInx-'+rInx">
                      <td>{{ r.brand }}</td>
                      <td>{{ r.customer }}</td>
                      <td>{{ r.created }}</td>
                      <td>{{ r.ide }}</td>

                      <td class="cell-buttons"><router-link class="btn btn-s1 bg-cprimary" :to="'/coa/'+r.id" target="_blank"><i class="fa fa-eye"></i> Detalle</router-link> </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-12 col-table-mobile">
              <div class="mobile-table" v-for="(r, rInx) in results" :key="'rInx-'+rInx">
                <div class="row _row">
                  <div class="col-4"><strong>Empresa</strong></div>
                  <div class="col-8">{{ r.brand }}</div>
                </div>

                <div class="row _row">
                  <div class="col-4"><strong>Cliente</strong></div>
                  <div class="col-8">{{ r.customer }}</div>
                </div>

                <div class="row _row">
                  <div class="col-4"><strong>Fecha</strong></div>
                  <div class="col-8">{{ r.created }}</div>
                </div>

                <div class="row _row">
                  <div class="col-4"><strong>ID</strong></div>
                  <div class="col-8">{{ r.ide }}</div>
                </div>

                <router-link class="btn btn-s1 bg-cprimary" :to="'/coa/'+r.id" target="_blank"><i class="fa fa-eye mr-1"></i> Detalle</router-link>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12 col-title">
              <h5 class="title-1">Resultados para el ID {{form.number}}</h5>
            </div>

            <div class="col-12 col-table">
              <div class="table-responsive-lg">
                <table class="table">
                  <thead>
                    <tr>

                      <th scope="col">ID</th>
                      <th class="cell-buttons" scope="col"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(r, rInx) in results" :key="'rInx-'+rInx">

                      <td>{{ form.number }}</td>

                      <td class="cell-buttons"><a class="btn btn-s1 bg-cprimary" :href="r.documentUrl" target="_blank"><i class="fa fa-file-pdf"></i> PDF</a> </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-12 col-table-mobile">
              <div class="mobile-table" v-for="(r, rInx) in results" :key="'rInx-'+rInx">
                <div class="row _row">
                  <div class="col-4"><strong>Empresa</strong></div>
                  <div class="col-8">{{ r.brand }}</div>
                </div>

                <div class="row _row">
                  <div class="col-4"><strong>Cliente</strong></div>
                  <div class="col-8">{{ r.customer }}</div>
                </div>

                <div class="row _row">
                  <div class="col-4"><strong>Fecha</strong></div>
                  <div class="col-8">{{ r.created }}</div>
                </div>

                <div class="row _row">
                  <div class="col-4"><strong>ID</strong></div>
                  <div class="col-8">{{ r.ide }}</div>
                </div>

                <router-link class="btn btn-s1 bg-cprimary" :to="'/coa/'+r.id" target="_blank"><i class="fa fa-eye mr-1"></i> Detalle</router-link>
              </div>
            </div>
          </div>

        </div>
        <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">

          <div v-html="modal.msg"></div>

        </sweet-modal>
        <sweet-modal blocking hide-close-button  ref="modalLoading">
          <!-- <div class="fa-3x" ><i class="fas fa-spinner fa-pulse"></i></div><br/> -->
          <p class="mb-2 text-center">
            <img class="img-fluid" src="public/images/loading_botella.gif" style="width: 340px;">
          </p>
          <div>Cargando...<br>Esta busqueda puede tomar un par de minutos. Un momento porfavor. </div>
          <progress id="downloadProgress" value="0" max="100" style="width: 100%;"></progress>
        </sweet-modal>
        <!--  -->
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1,

      form: {
        number: null
      },

      results: [

      ],
      typesearch:null,
      modal:{
        icon:null,
        msg:null,
        block:null,
      },
      ids:null,
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.$refs.modalLoading.open();

      var progressBar = document.getElementById("downloadProgress");
    var downloadPercent = 0;
    var totalDuration = 4 * 60 * 1000; // 4 minutos en milisegundos
    var intervalDuration = totalDuration / 100; // Tiempo para incrementar 1% del progreso
    
    // Simular la descarga
    var downloadTimer = setInterval(function() {
      downloadPercent += 1;
      progressBar.value = downloadPercent;
      if (downloadPercent === 100) {
        clearInterval(downloadTimer);
      }
    }, intervalDuration);
    
  
      axios.post(tools.url('/api/searchcertificate'),{ide:this.form.number,ids:this.ids}).then((response)=>{
        this.step = 2;
        this.results = response.data.rows;
        if(response.data.type == 1){
            this.typesearch = 1;
        }
        else{
          this.typesearch = 2;
        }


        this.$refs.modalLoading.close();
      }).catch((error)=>{
        this.modal.block = false;
        this.modal.icon = 'warning';
        this.modal.msg = error.response.data.msg;
        this.$refs.modal.open();
        this.$refs.modalLoading.close();
        console.log(error);
      })
    },
  },
  mounted(){
    if(this.$route.query.ids){
        this.ids = this.$route.query.ids;
        const boton = document.getElementById('miBoton');

      // Haz clic en el botón usando el método click()
      boton.click();
    }
  }
    
}
</script>
<style>
  /* Estilos personalizados para el progress */
  progress {
    width: 100%;
    height: 20px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  /* Color para Chrome, Safari, Edge, Opera */
  progress::-webkit-progress-value {
    background-color: #57b68c; /* Cambia este color */
  }
  
  progress::-webkit-progress-bar {
    background-color: #ddd; /* Color del fondo de la barra */
  }

  /* Color para Firefox */
  progress::-moz-progress-bar {
    background-color: #57b68c; /* Cambia este color */
  }
</style>